// extracted by mini-css-extract-plugin
export default {"text":"ProgramTerdekat_text__o88m6","programItems":"ProgramTerdekat_programItems__C8orr","btnContainer":"ProgramTerdekat_btnContainer__Vm9qY"};